import React from "react";

import { formatAbsoluteTime } from "~/tools/date-time/format/format-absolute-time";

import { TableRow } from "../../bottom_content/view/panes/east/element-details/modal-dialog/TableRow";
import { Widget } from "../_widget";
import { Tag } from "../react/expandable-list/Tag";
import { Markdown } from "../react/markdown/Markdown";
import { SortedTagList } from "../react/sorted-tag-list/SortedTagList";

export const GeneralPropertiesTabLayout: React.FC<
	React.PropsWithChildren<{
		name: string;
		description: undefined | string;
		componentTypeName: undefined | string;
		version?: string;
		labels: Array<string>;
		identifiers: undefined | Array<string>;
		syncNames: undefined | Array<string>;
		lastUpdateTimestamp: undefined | number;
		id?: undefined | number;
	}>
> = ({
	name,
	description,
	componentTypeName = "",
	version,
	labels,
	identifiers,
	syncNames,
	lastUpdateTimestamp,
	children,
	id = null,
}) => (
	<Widget
		card
		className="max-h-[85vh] w-full overflow-y-auto"
		compact
		data-testid="element-general-properties"
		frameless
	>
		<TableRow label="Name">{name}</TableRow>

		<TableRow label="Type">
			<Tag text={componentTypeName} />
		</TableRow>

		<TableRow label="Labels">
			<SortedTagList items={labels} />
		</TableRow>

		{version && <TableRow label="Version">{version}</TableRow>}

		<TableRow label="Last updated">{formatAbsoluteTime(lastUpdateTimestamp).toString()}</TableRow>

		{description && (
			<TableRow label="Description">
				<Markdown onlyLinks text={description} />
			</TableRow>
		)}

		{identifiers != null && (
			<TableRow label="Identifiers">
				<SortedTagList items={identifiers} />
			</TableRow>
		)}

		{id && <TableRow label="Id">{id}</TableRow>}

		{syncNames && (
			<TableRow label="Sync sources">
				<SortedTagList items={syncNames} />
			</TableRow>
		)}

		{children}
	</Widget>
);
